import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo } from 'src/types/base';

export declare namespace AlgaPictureDOI {
    export interface RowDataI {
        id: number;
        file_name: string;
        file_url: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        start_time: number;
        end_time: number;
    }
}

export default class AlgaPictureApi {
    static async searchList(params: AlgaPictureDOI.QueryRowDataParamsI): Promise<ResultPageDo<AlgaPictureDOI.RowDataI[]>> {
        return Api.post('/ops/large_file/list/get', params);
    }

    static async delete(id: number): Promise<Result<any>> {
        return Api.post('/ops/large_file/delete', { id });
    }
}
